function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46.64 12.73l-4.13 4.14c-.42.42-1.1.42-1.53 0l-9.95-9.95a1.08 1.08 0 010-1.53l4.13-4.13a4.31 4.31 0 016.1 0l5.38 5.39a4.3 4.3 0 010 6.08zM27.48 8.94L3.93 32.5l-1.9 10.89a2.15 2.15 0 002.5 2.5l10.89-1.92 23.55-23.54c.42-.42.42-1.1 0-1.53L29 8.94a1.09 1.09 0 00-1.53 0zM13.12 30.47c-.49-.5-.49-1.28 0-1.78l13.81-13.8c.5-.5 1.28-.5 1.78 0 .5.49.5 1.28 0 1.77L14.9 30.46c-.5.5-1.28.5-1.78 0zM9.9 38h4.3v3.25l-5.78 1.02-2.79-2.8 1.01-5.77H9.9V38z"
})));